import React from "react";
import moment from "moment";
import { Grid } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faWarehouse } from "@fortawesome/pro-regular-svg-icons";
import { withTranslation } from "react-i18next";

import { DesktopOnly } from "../../../../layout";
import { getTyreStatus } from "../../../../util/common";
import { getTyreSeasonIcon, TYRE_POSITION } from "../../../../util/tyre";

import "./index.scss";

const ON_CAR_POSITIONS = [TYRE_POSITION.CAR_FRONT_LEFT, TYRE_POSITION.CAR_FRONT_RIGHT, TYRE_POSITION.CAR_REAR_LEFT, TYRE_POSITION.CAR_REAR_RIGHT];

const IN_STORAGE_POSITIONS = [TYRE_POSITION.STORAGE_FRONT_LEFT, TYRE_POSITION.STORAGE_FRONT_RIGHT, TYRE_POSITION.STORAGE_REAR_LEFT, TYRE_POSITION.STORAGE_REAR_RIGHT];

const TyresOverviewV2 = ({ communication, settings, t }) => {
  const tyres = communication.car?.tyres ?? [];

  const onCarTyres = tyres.filter(carTyre => ON_CAR_POSITIONS.includes(carTyre.position));
  const inStorageTyres = tyres.filter(carTyre => IN_STORAGE_POSITIONS.includes(carTyre.position));

  if (!onCarTyres.length && !inStorageTyres.length) return null;

  const renderTyres = (leftTyre, rightTyre) => {
    if (!leftTyre && !rightTyre) return null;

    return (
      <div className="tyre-overview-section-content-container">
        <div className="tyre-overview-section-inner-container">
          {leftTyre && (
            <>
              <div className="tyre-overview-section">
                <div className={`tyre-overview-section-box ${getTyreStatus(leftTyre.profile, leftTyre.tyre?.season, settings)}`}>
                  <span>L</span>
                </div>
                <span className="tyre-overview-profile-text">{leftTyre.profile} mm</span>
              </div>
              <div className="tyre-overview-manufacturer-container">
                <div className="tyre-overview-manufacturer-inner">
                  {leftTyre.tyre?.manufacturer} {getTyreSeasonIcon(leftTyre.tyre?.season)}
                </div>
                <div className="tyre-overview-manufacturer-inner">{leftTyre.tyre?.description}</div>
              </div>
            </>
          )}
        </div>
        <div className="tyre-overview-section-inner-container right-tyre">
          {rightTyre && (
            <>
              <div className="tyre-overview-section">
                <span className="tyre-overview-profile-text right-profile">{rightTyre.profile} mm</span>
                <div className={`tyre-overview-section-box ${getTyreStatus(rightTyre.profile, rightTyre.tyre?.season, settings)}`}>
                  <span>R</span>
                </div>
              </div>
              <div className="tyre-overview-manufacturer-container">
                <div className="tyre-overview-manufacturer-inner">
                  {getTyreSeasonIcon(rightTyre.tyre?.season)} {rightTyre.tyre?.manufacturer}
                </div>
                <div className="tyre-overview-manufacturer-inner">{rightTyre.tyre?.description}</div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const renderTyresSection = (sectionTyres, [flPosition, frPosition, rlPosition, rrPosition], icon, title) => {
    if (!sectionTyres.length) return null;

    const findTyre = position => sectionTyres.find(carTyre => carTyre.position === position);
    const lastUpdatedOn = moment.max(sectionTyres.map(carTyre => moment(carTyre.updated_on))).format("DD-MM-YYYY");

    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <div className="tyre-overview-sub-heading">
            <FontAwesomeIcon icon={icon} className="tyre-overview-sub-heading-icon" />
            <h4 className="tyre-overview-sub-heading-title">{`${title} ${lastUpdatedOn}`}</h4>
          </div>
        </Grid.Column>
        <Grid.Column computer={8} mobile={16} className="tyre-overview-left-section-container">
          <div className="tyre-overview-section-heading-container">
            <span className="tyre-overview-section-heading-title">{t("cc_FRONT_TYRES").message || "FRONT TYRES"}</span>
          </div>
          {renderTyres(findTyre(flPosition), findTyre(frPosition))}
        </Grid.Column>
        <Grid.Column computer={8} mobile={16} className="tyre-overview-right-section-container">
          <div className="tyre-overview-section-heading-container">
            <span className="tyre-overview-section-heading-title">{t("cc_REAR_TYRES").message || "REAR TYRES"}</span>
          </div>
          {renderTyres(findTyre(rlPosition), findTyre(rrPosition))}
        </Grid.Column>
      </Grid.Row>
    );
  };

  return (
    <DesktopOnly>
      <Grid className="tyre-overview-container component-container">
        {renderTyresSection(onCarTyres, ON_CAR_POSITIONS, faCar, t("cc_Tire_control_on_car_datum").message || "Tire - On car - Control date")}
        {renderTyresSection(inStorageTyres, IN_STORAGE_POSITIONS, faWarehouse, t("cc_Tire_control_in_storage_datum").message || "Tire - In storage - Control date")}
      </Grid>
    </DesktopOnly>
  );
};

export default withTranslation()(TyresOverviewV2);
